module.exports = __webpack_public_path__ + "img/feature-projects.ccca012721962a3faed5a33ac8c1721c.png";